import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ApontamentoOP from "model/producao/ApontamentoOP";
import Estagio from "model/producao/Estagio";
import EstagioOP from "model/producao/EstagioOP";
import ItemPedido from "model/producao/ItemPedido";
import LoteComponenteOP from "model/producao/LoteComponenteOP";
import OrdemProducao from "model/producao/OrdemProducao";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { generateKey } from "utils/generateKey";

class ApontamentoOpService {
    
    pesquisar(page: Pageable, filters: DataTableFilterMeta[], idEstagio: number, status: string) {
        return new Promise<Page>((resolve, reject): void => {
            const url = `/apontamentoOp/pesquisar/${idEstagio}/${status}`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultarEstagio(id: number): Promise<EstagioOP> {
        return new Promise<EstagioOP>((resolve, reject): void => {
            const url = `/apontamentoOp/estagioOp/${id}`;
            api
                .get(url)
                .then(response => {
                    const estagioOP = response.data as EstagioOP;
                    estagioOP.componentes.forEach(componente => {
                        componente.key = generateKey();
                        if (componente.lotes) {
                            const lotes = componente.lotes.map(lote => {
                                lote.key = generateKey();
                                return lote;
                            });
                            componente.lotes = lotes;
                        }

                    });
                    resolve(estagioOP)
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    estagios(): Promise<Estagio[]> {
        return new Promise<Estagio[]>((resolve, reject): void => {
            const url = "/apontamentoOp/estagios";
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    apontar(apontamento: ApontamentoOP): Promise<void> {
        return new Promise<void>((resolve, reject): void => {
            const url = `/apontamentoOp/apontar`;
            api
                .post(url, apontamento)
                .then(response => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    lotesDisponiveis(produto: Produto): Promise<LoteComponenteOP[]> {
        const url = `/apontamentoOp/lotesDisponiveis/${encodeURIComponent(produto.codigo as string)}`;
        return new Promise<LoteComponenteOP[]>((resolve, reject): void => {
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    materiasPrimas() {
        const url = `/apontamentoOp/materiasPrimas`;
        return new Promise<Produto[]>((resolve, reject) => {
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    sugerirLotes(produto: Produto, quantidade: number){
        const url = `/apontamentoOp/lotesSugeridos/${encodeURIComponent(produto.codigo as string)}/${encodeURIComponent(quantidade)}`;
        return new Promise<LoteComponenteOP[]>((resolve, reject): void => {
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    opTemReprovacao(id: number) {
        const url = `/apontamentoOp/temReprovacao/${id}`;
        return new Promise<boolean>((resolve, reject) => {
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }
}

export default ApontamentoOpService;